import * as service from "../service";
import type { ServiceResponse } from "../types";
import type { BusinessPlanType } from "./getBusinessPlan";

type CreateCheckoutSessionParams = {
  plan_type: BusinessPlanType;
};

/**
 * Start a Stripe Checkout subscription for the chosen plan and return the
 * redirect URL the browser should follow.
 * Backend: POST /api/business/plan/createCheckout
 */
export const CreateCheckoutSessionAPI = async ({
  plan_type,
}: CreateCheckoutSessionParams): Promise<ServiceResponse<{ url?: string }>> => {
  try {
    const resp = (await service.call(
      "POST",
      "api/business/plan/createCheckout",
      { plan_type },
    )) as ServiceResponse<{ url?: string }>;
    return resp;
  } catch (err) {
    console.error(`CreateCheckoutSessionAPI ${err}`);
    return { status: -1, error: err };
  }
};
